export default __webpack_public_path__ + "52f2b51b366bcbb7999bf2ae0801b48c.woff?proxy=wpt-abc";